import React from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { LinkProps, LinkStylesStructure } from '@pijma/hero-types'
import { useStyles } from '@pijma/theme-provider'

import { LinkBaseStyles } from './Link.style'

export const Link = (props: LinkProps) => {
  const {
    classNames: { root },
  } = useStyles<LinkStylesStructure>(['Link'], props, {
    defaultStyles: LinkBaseStyles,
  })
  return (
    <PijmaComponent
      as="a"
      commonProps={props}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onClick={props.onPress}
      target={props.target}
      href={props.url}
      className={root}
    >
      {props.children}
    </PijmaComponent>
  )
}

Link.displayName = 'Link'
